import { Icon } from './icon';
import { Button } from './Button';

/**
 * Mockup `.empty-state`: centered block with a 72px pink circle + saint-john
 * icon, 18px title, gray body, and an optional primary CTA. Used for empty
 * lists, gap'd widgets ("Sem dados ainda"), and the Settings stub.
 */
export function EmptyState({
  icon,
  title,
  description,
  cta,
}: {
  icon: string;
  title: string;
  description: string;
  cta?: { label: string; onClick: () => void };
}): JSX.Element {
  return (
    <div className="px-6 py-20 text-center text-[var(--m-fg-muted)]">
      <span className="mb-4 inline-flex h-[72px] w-[72px] items-center justify-center rounded-full bg-[var(--m-bg-alt)] text-[var(--m-brand-press)]">
        <Icon name={icon} size={28} />
      </span>
      <h3 className="m-0 mb-1.5 text-[18px] font-bold text-[var(--m-fg)]">{title}</h3>
      <p className="m-0 text-[var(--m-fg-muted)]">{description}</p>
      {cta && (
        <Button variant="primary" icon="plus" className="mt-4" onClick={cta.onClick}>
          {cta.label}
        </Button>
      )}
    </div>
  );
}
